<template>
    <b-modal ref="marshalNotesModal" id="marshalNotesModal" title="Marshal Notes" @shown="shown" @hidden="closing" size="xl" centered>
        <div v-if="bookings">
            <b-row v-for="booking in bookings" v-if="bookings.length" :key="booking.id">
                <b-col>
                    <dl class="border rounded p-2">
                        <dd>Member: {{ booking.member.forename }} {{ booking.member.surname }}</dd>
                        <dt>
                            <dl v-for="note in booking.notes" :key="note.id" :code="`${note.id}`" :ref="`note-${note.id}`" class="border rounded p-2 mb-2">
                                <dd class="mb-0"><small>Marshal</small></dd>
                                <dt class="mb-1">{{ note.user.name }}</dt>
                                <dd class="mb-0"><small>Location</small></dd>
                                <dt class="mb-1">{{ booking.game.site.title }}</dt>
                                <dd class="mb-0"><small>Game Date</small></dd>
                                <dt class="mb-1">{{ getGameDate(booking.game.start_time) }}</dt>
                                <dd class="mb-0"><small>Note</small></dd>
                                <dt class="mb-1">{{ note.message }}</dt>
                            </dl>
                        </dt>
                    </dl>
                </b-col>
            </b-row>
        </div>


        <template #modal-footer="{  }"><div></div></template>
    </b-modal>
</template>

<script>
import moment from 'moment-timezone';

export default {
    props: {
        show: {
            default: false,
        },
        notes: {
            default: [],
        },
    },
    data() {
        return {
            showing: false,
            observer: null,
        };
    },
    watch: {
        show: function (val) {
            if (val) {
                this.$nextTick(() => {
                    this.showModal();
                });
            } else {
                this.$nextTick(() => {
                    this.hideModal();
                    this.disconnectObserver();
                });
            }
        },
    },
    computed: {
        bookings() {
            // Iterate over the notes and group them by booking
            let bookings = [];

            this.notes.forEach(note => {
                let booking = bookings.find(booking => booking.id === note.note_id);

                if (!booking) {
                    booking = {
                        id: note.note_id,
                        member: note.note.member,
                        game: note.note.game,
                        notes: [],
                    };

                    bookings.push(booking);
                }

                booking.notes.push(note);
            });

            return bookings;
        },
    },
    methods: {
        getGameDate(date) {
            return moment(date).tz('Europe/London').format('dddd, MMMM Do YYYY, HH:mm');
        },
        showModal() {
            this.$refs.marshalNotesModal.show();
            this.showing = true;
        },
        hideModal() {
            if (this.showing) {
                this.$refs.marshalNotesModal.hide();
            }
        },
        closing() {
            this.showing = false;
            this.$emit('closing');
        },
        shown() {
            setTimeout(() => {
                this.initObserver();
            }, 500);
        },
        initObserver() {
            this.observer = new IntersectionObserver(this.handleIntersect, {
                root: null,
                rootMargin: '0px',
                threshold: 1.0,
            });

            this.$nextTick(() => {
                this.bookings.forEach(booking => {
                    booking.notes.forEach(note => {
                        const noteElement = this.$refs['note-' + note.id];
                        if (noteElement) {
                            this.observer.observe(noteElement[0]);
                        }
                    });
                });
            });
        },
        disconnectObserver() {
            if (this.observer) {
                this.observer.disconnect();
            }
        },
        handleIntersect(entries) {
            entries.forEach(entry => {
                if (entry.isIntersecting) {
                    const noteId = entry.target.getAttribute('code');
                    this.markNoteAsSeen(noteId);
                }
            });
        },
        markNoteAsSeen(noteId) {
            axios.post(this.$routes.route('seenNotes.store'), {note_id: noteId})
                .then(response => {
                    console.log(response);
                })
                .catch(error => {
                    console.log(error);
                });
        },
        init() {
        },
    },
    mounted() {
    },
}
</script>